<template>
 <div style="padding-top:100px">
    <div class="win" :style="'background-size:100%;background-image:url('+oss+data.style.backgroundImage+');background-color:'+data.style.backgroundColor">
    <div class="main" >
      <div class="title" :style="'color:'+data.style.tipsColor">{{data.params.tips}}</div>
    <div class="btn" :style="'background-image:url('+oss+data.style.backgroundButtomImage+');background-size:100%;background-color:'+data.style.buttonColor+';color:'+data.style.buttonTextColor">
        前往会员中心
      </div>
    </div>
  </div>
 </div>
</template>
<script>
import config from "@/config";
export default {
  name: "notWinning",
  props: { data: Object },
  setup() {
    const oss = config.oss[process.env.VUE_APP_type];
    return {
      oss,
    };
  },
};
</script>

<style lang="less" scoped>
.win {
  width: 300px;
  height: 300px;
  margin: 0 auto;
  background-repeat: no-repeat;
  background-size: 100%;
  background-position: center;
  position: relative;
  border-radius: 10px;
  padding-top: 40px;
  .main {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    border-radius: 10px;
    color: #8E0707;
    .title{
      max-width:70%;
      font-size: 16px;
      margin: 0 auto;
    }
  }
  .btn{
    background-color: #FFAE59;
    color: #fff;
    width: 150px;
    border-radius: 20px;
    height: 44px;
    text-align: center;
    line-height: 44px;
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
  }
}
</style>